import controller from './template-detail.controller';
import templateBase from './templates/template-detail-base.view.html';
import adaptativo from "./templates/template-detail-adaptativo.view.html";

let TemplateDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
    if(__env.adaptative){
      return adaptativo;
    } else {
        return templateBase;
    }
}


export default TemplateDetailComponent;



/** WEBPACK FOOTER **
 ** ./www/components/templates/template-detail/template-detail.component.js
 **/